/* eslint-disable max-len */
import { LitElement, html, css } from 'lit';

export class BlankFrame extends LitElement {
	render() {
		return html``;
	}
}

customElements.define('studio-gallery-blank-frame', BlankFrame);
